import PropTypes from 'prop-types';
import React from 'react';
import { trackEvent } from 'dibs-tracking';
import Dropdown, { sizeConstants } from '../Dropdown/Dropdown';
import SiteNavDropdownContent from './SiteNavDropdownContent';

import styles from './SiteNav-style.scss';

class SiteNavItem extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        const { name } = this.props;

        trackEvent({
            action: 'header navigation click',
            category: 'navigation',
            label: `${name.toLowerCase()} header link|${name.toLowerCase()}`,
        });
    }
    render() {
        const { name, url, items } = this.props;
        return (
            <div className={styles.item}>
                <Dropdown size={sizeConstants.SIZE_EXTRA_LARGE}>
                    <a
                        className={styles.itemLink}
                        href={url}
                        data-tn={`global-nav-item-link-${name
                            .toLowerCase()
                            .replace(/[^a-zA-Z0-9]+/gi, '-')}`}
                        onClick={this.handleClick}
                    >
                        {name}
                    </a>
                    {items && items.length ? (
                        <SiteNavDropdownContent items={items} trackingLabelPrefix={name} />
                    ) : null}
                </Dropdown>
            </div>
        );
    }
}

SiteNavItem.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    items: PropTypes.array,
};

export default SiteNavItem;
